// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bf6a3660","453":"a7cc54bf","455":"3531485e"}[chunkId] + ".chunk.js";
};